import {UserProvider} from './UserContext'
import {AuthProvider} from './AuthContext'
import {FriendRequestCountProvider} from './FriendRequestCountContext'
import {FavoritesProvider} from './FavoritesContext'
import React from 'react'

/**
 * Composite context provider that combines all app contexts
 * Order matters: User → Auth (Auth depends on User) → FriendRequestCount/Favorites (depend on User)
 */
const AppContextProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
  return (
    <UserProvider>
      <AuthProvider>
        <FriendRequestCountProvider>
          <FavoritesProvider>
            {children}
          </FavoritesProvider>
        </FriendRequestCountProvider>
      </AuthProvider>
    </UserProvider>
  )
}

export default AppContextProvider
